function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Arrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 27 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.104,0.005c-0.183,-0.019 -0.371,0.012 -0.543,0.096c-0.343,0.167 -0.561,0.517 -0.561,0.899l0,4.068l-13,0c-1.105,0 -2,0.895 -2,2l0,2c0,1.105 0.895,2 2,2l13,0l0,4.072c0,0.383 0.218,0.732 0.561,0.899c0.14,0.069 0.29,0.101 0.439,0.101c0.219,0 0.436,-0.07 0.615,-0.209l9.071,-7.072c0.243,-0.19 0.384,-0.478 0.384,-0.787c0,-0.309 -0.141,-0.6 -0.384,-0.789l-9.071,-7.072c-0.151,-0.118 -0.329,-0.186 -0.511,-0.206Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Arrow);
export default __webpack_public_path__ + "static/media/icons8-arrow.c77ca21043e92e61f81118292efdb95d.svg";
export { ForwardRef as ReactComponent };